import React from "react";
import Person from "../Person";
import SearchSettings from "./SearchSettings"
import { withRouter } from "react-router";

const matching = require("./matching");

const background_style = {
    "left":"0%",
    "right":"0%",
    "top":"0%",
    "bottom":"0%",
    "background":"#F6F7F9",
};

class Matches extends React.Component{
    
    handleClick = () => {
        console.log(this.props.user)
        this.props.history.push({ 
            pathname: "/searchsettings",
            state: { user: this.props.user },
          });
    }

    render() {
        const displayAttributes = ["full_name"];
        let sortMatches = matching.rank(this.props.user, this.props.matchList, this.props.matchFields, this.props.cityScore).sort(function(first, second) {
            return second.rank - first.rank;
        });
        const matches = sortMatches.map((match) =>{
                let person = null;
                if (match.attribute.activity_status){
                    person = <div key={match.attribute["email"]}>
                        <Person attributes = {match.attribute} displayAttributes = {displayAttributes}/>
                    </div>
                }
                return person
        }
        );
        return(
            <div style={background_style}>
                {/*
                <a onClick={this.handleClick} style={{cursor:"pointer", fontSize:"16px", color: 'green'}}>שנה אפשרויות חיפוש</a>
                */}
                {/* <br/>
                <br/> */}
                {matches}
            </div>
        )
    }
}

export default withRouter(Matches)